import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const EXPORT_TEMPLATES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('EXPORT_TEMPLATES');
export const EXPORT_TEMPLATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	EXPORT_TEMPLATES_CRUD_ACTION_CONSTANTS
);
